/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:17:58
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-28 14:49:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/common.ts
 */
import { generateLinkImg } from 'src/constrains/DraggableModules/tools';
import { generateNewItem } from 'src/constrains/MenuSortableTree';

export enum EnumCollapseId {
  topLeaderBoardBanner = 'saleChannelContentAllProductsPageTopLeaderBoardBanner',
  productMenu = 'saleChannelContentAllProductsPageProductMenu',
  miniProgramShare = 'saleChannelContentHomepageMiniProgramShare',
  miniProgramPageInfo = 'saleChannelContentHomepageMiniProgramInfo',
  gridSetting = 'saleChannelContentAllProductGridSetting',
}
export const fixedCollapse = [
  EnumCollapseId.topLeaderBoardBanner,
  EnumCollapseId.productMenu,
  EnumCollapseId.miniProgramShare,
  EnumCollapseId.miniProgramPageInfo,
  EnumCollapseId.gridSetting,
];

export const _newMenu = (title = '') => {
  return { title, linkModule: generateLinkImg(1)[0], children: [] };
};

export const generateMenuItem = () => {
  return generateNewItem(_newMenu(''));
};

export const generateDefaultTopLeaderBoardBanner = () => {
  return { enabled: true, linkModule: generateLinkImg(1)[0] };
};

export const generateDefaultProductMenu = () => {
  return {
    enabled: true,
    roots: [generateNewItem(_newMenu('Item 1'))],
  };
};

export const generateDefaultGridSetting = () => {
  return {
    buttonThemeUuid: null,
    displayProductDescription: false,
    displayRRP: false,
    display2ndCurrencyPrice: false,
    displayProductReview: false,
    displayProductPromotionTag: false,
  };
};
